import { Accordion, Typography, AccordionSummary, Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { FC } from 'react';
import { useToggle } from '../../../../../../../../../../../hooks/use-toggle';
import { ItemOf, Optional } from '@vy/utils';
import { MorningIntegrationStatusAccordionDetails } from './morning-integration-status-accordion-components/MorningIntegrationStatusAccordionDetails';
import { GetLightInvoicesResponse, GetExportedIntegrationsResponse } from '@vy/api-definition';
import { SYNC_JOB_STATUSES } from '@vy/integrations-types';

type MorningIntegrationStatusAccordionProps = {
  morningIntegration: Optional<ItemOf<GetExportedIntegrationsResponse>>;
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
};

export const MorningIntegrationStatusAccordion: FC<MorningIntegrationStatusAccordionProps> = ({
  morningIntegration,
  invoice,
}) => {
  const [expanded, toggleExpanded] = useToggle(true);
  const isSynced = morningIntegration?.status === SYNC_JOB_STATUSES.COMPLETED;

  return (
    <Accordion expanded={expanded} onChange={() => toggleExpanded()} sx={{ p: 0 }}>
      <AccordionSummary
        expandIcon={
          <VyIcon
            icon="ArrowDown"
            style={{
              color: '#323232',
            }}
          />
        }
        sx={{ p: 0, height: '34px', alignItems: 'center' }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1
          }}>
          <VyIcon icon="Synchronize" />
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: "24px"
            }}>
            Integration status
          </Typography>

          {isSynced && (
            <div
              style={{
                width: '8px',
                height: '8px',
                backgroundColor: '#65CF7E',
                borderRadius: '50%',
              }}
            />
          )}
        </Stack>
      </AccordionSummary>
      <MorningIntegrationStatusAccordionDetails morningIntegration={morningIntegration} invoice={invoice} />
    </Accordion>
  );
};
